/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './paramedic-referral.reducer';

export const ParamedicReferralDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paramedicReferralEntity = useAppSelector(state => state.paramedicReferral.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paramedicReferralDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paramedicReferral.detail.title">ParamedicReferral</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.id">Id</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.id}</dd>
          <dt>
            <span id="referralTypeCode">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.referralTypeCode">Referral Type Code</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.referralTypeCode}</dd>
          <dt>
            <span id="referralName">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.referralName">Referral Name</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.referralName}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.active">Active</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.cursor}</dd>
          <dt>
            <span id="served">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.served">Served</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.served ? 'true' : 'false'}</dd>
          <dt>
            <span id="referralNotes">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.referralNotes">Referral Notes</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.referralNotes}</dd>
          <dt>
            <span id="accepted">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.accepted">Accepted</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.accepted ? 'true' : 'false'}</dd>
          <dt>
            <span id="rejected">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.rejected">Rejected</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.rejected ? 'true' : 'false'}</dd>
          <dt>
            <span id="rejectNotes">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.rejectNotes">Reject Notes</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.rejectNotes}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.patientType}</dd>
          <dt>
            <span id="exposed">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.exposed">Exposed</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.exposed ? 'true' : 'false'}</dd>
          <dt>
            <span id="sourceAppointmentId">
              <Translate contentKey="tinyMedicRestApp.paramedicReferral.sourceAppointmentId">Source Appointment Id</Translate>
            </span>
          </dt>
          <dd>{paramedicReferralEntity.sourceAppointmentId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferral.admission">Admission</Translate>
          </dt>
          <dd>{paramedicReferralEntity.admission ? paramedicReferralEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferral.referredTo">Referred To</Translate>
          </dt>
          <dd>{paramedicReferralEntity.referredTo ? paramedicReferralEntity.referredTo.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferral.referredAt">Referred At</Translate>
          </dt>
          <dd>{paramedicReferralEntity.referredAt ? paramedicReferralEntity.referredAt.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferral.referredBy">Referred By</Translate>
          </dt>
          <dd>{paramedicReferralEntity.referredBy ? paramedicReferralEntity.referredBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paramedicReferral.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{paramedicReferralEntity.glucoUser ? paramedicReferralEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/paramedic-referral" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/paramedic-referral/${paramedicReferralEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParamedicReferralDetail;
